import { useSelector } from 'react-redux';
import RegistrationTable from './RegistrationTable';
import {
  selectLegalEntities,
  selectRegistrationData,
  selectRegistrationStatus,
  selectUseExistingAccount,
  selectCredentials,
  registerCompany,
} from '../../../entities/registration/model';
import { Button } from '../../../shared/ui/button';
import { useAppDispatch } from '../../../app/store/store';
import { RegisterHeader } from './RegistrationStepCompanyData';

export const RegistrationStepShowAllData = () => {
  const registrationData = useSelector(selectRegistrationData);
  const legalEntities = useSelector(selectLegalEntities);
  const status = useSelector(selectRegistrationStatus);
  const useExistingAccount = useSelector(selectUseExistingAccount);
  const user = useSelector(selectCredentials);
  const dispatch = useAppDispatch();
  const registerSubmit = () => {
    dispatch(registerCompany(registrationData));
  }

  return (
    <>
      <RegisterHeader step={5} isBack={true} stepSize={4} title="Подтверждение" />

      {useExistingAccount && (
        <div className="w-full max-w-[500px] mx-auto mb-4 p-4 rounded-md bg-blue-50 border border-blue-200">
          <p>Имя: {user.first_name}</p>
          <p>Фамилия: {user.last_name}</p>
          <p>Email: {user.email}</p>
          <p>Логин: {user.username}</p>
          {user.mobile_phone && <p>Телефон: {user.mobile_phone}</p>}
        </div>
      )}

      <RegistrationTable legalEntities={legalEntities}/>
      <Button type={'submit'} status={status} onClick={registerSubmit}>
        Подтвердить
      </Button>
    </>
  );
};
